import { useTranslation } from 'react-i18next';
import { CARD_COLORS } from '../../views/cards/cardRules';
import type { ICardColourRule } from '../../views/cards/ICardColourRule';
import { ColourRuleCard } from './ColourRuleCard';
import type { IViewColourRulesProps } from './IViewColourRulesProps';

/**
 * «Кольори карток · діє перше правило, що збіглося» (прототип v4): картки правил; без правил — «Правил кольору немає — картки мають типовий
 * фон.»; «+ Додати правило кольору» — правило за пріоритетом (інакше статусом) з наступним кольором палітри.
 */
export function ViewColourRules({ rt, rules, onChange }: IViewColourRulesProps) {
  const { t } = useTranslation();
  const set = (i: number, next: ICardColourRule) => onChange(rules.map((r, j) => (j === i ? next : r)));
  const up = (i: number) => {
    if (i <= 0) return;
    const next = [...rules];
    [next[i - 1], next[i]] = [next[i]!, next[i - 1]!];
    onChange(next);
  };
  const add = () => {
    const field = (rt.fields.find((f) => f.key === 'priority') ?? rt.fields.find((f) => f.key === 'status') ?? rt.fields[0])?.key ?? 'status';
    onChange([...rules, { field, op: 'eq', value: '', color: CARD_COLORS[rules.length % CARD_COLORS.length]!.hex }]);
  };
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('listViews.vs.colours')}</span>
      {rules.map((r, i) => (
        <ColourRuleCard key={i} rt={rt} rule={r} index={i} onChange={(next) => set(i, next)} onUp={() => up(i)} onRemove={() => onChange(rules.filter((_, j) => j !== i))} />
      ))}
      {rules.length === 0 && <span className="lv-vs__hint">{t('listViews.vs.noRules')}</span>}
      <button type="button" className="lv-adv__add lv-vs__add" onClick={add}>{t('listViews.vs.addRule')}</button>
    </div>
  );
}
